import {Law} from "./laws";

export class RegistrationLaw {
  public id: string;
  public registrationId: string;
  public law: Law;
  public sortOrder: number;
}
